// A company/org name tinted with its brand color, with a soft bloom of the same
// color so it reads as part of the CRT treatment rather than a stray link.
//
// A couple of these are lifted off the real mark: Capital One's navy and UMD's
// red are both too dark to sit on a black page, so they use a brighter step of
// the same hue. UMIACS takes UMD's gold instead of its red purely so it doesn't
// land next to TerpLabs as a second, near-identical red.
export default function Co({ color, children }) {
    return (
        <span className = "about-co" style = {{ color }}>{children}</span>
    )
}
